import { Accordion } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { Alert, Button, Loading } from '../../components';
import { CustomAccordionSummary, panelFundingConfig } from '../Assessment';
import { PanelCard } from './components';
import { useGetPanelCards } from './graphql';
import { PANEL_HOME_PAGE_TEXT } from './lang';

export const PanelHomePage: React.FunctionComponent = () => {
  const { panelCardsList, loading, error } = useGetPanelCards({
    status: {
      ne: 'COMPLETED',
    },
  });

  if (error) {
    return (
      <Alert
        openAlert
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  const handleCardClick = (panelId: string) => (): void => {
    window.location.href = `/internal/panel-homepage/panel-details/${panelId}`;
  };

  const handleEnterReviewVersion = (panelId: string) => (): void => {
    window.location.href = `/internal/panel-homepage/panel-review-list/${panelId}`;
  };
  return (
    <PageContainer>
      {loading ? (
        <Loading />
      ) : (
        <>
          <h1>{PANEL_HOME_PAGE_TEXT.TITLE}</h1>
          {panelCardsList.map((panelCardList, index) => {
            const hasCards = panelCardList.panelCards.length > 0;
            const { fundingSource, funding, panelCards } = panelCardList;
            return (
              <Accordion
                key={index}
                defaultExpanded={hasCards}
                disabled={!hasCards}
                sx={{
                  ':before': { display: 'none' },
                  '.MuiButtonBase-root': { minHeight: '0px !important' },
                  '.MuiAccordionSummary-content': {
                    margin: '0 !important',
                  },
                  marginBottom: '2rem',
                  boxShadow: 'none',
                  backgroundColor: '#ffffff !important',
                }}
              >
                <CustomAccordionSummary>
                  <span className="font-medium text-lg">{fundingSource}</span>
                </CustomAccordionSummary>
                <div className="flex flex-row flex-wrap px-4 py-2">
                  {panelCards.map((panelCard, index) => {
                    const { panelId, title, startDate, panelType, endDate } =
                      panelCard;

                    const panelCardProp = {
                      panelId,
                      title,
                      startDate,
                      panelType,
                      endDate,
                      handleCardClick: handleCardClick(panelId),
                    };

                    return (
                      <div key={index} className="p-5">
                        <PanelCard {...panelCardProp} />
                        {/* hide reviewer section non-HKPFS panel */}
                        {panelFundingConfig(funding).showReviewer && (
                          <div className="m-3">
                            <Button
                              variant="text"
                              className="!normal-case !underline !font-semibold"
                              onClick={handleEnterReviewVersion(panelId)}
                            >
                              {PANEL_HOME_PAGE_TEXT.APPLICATION_REVIEW}
                            </Button>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </Accordion>
            );
          })}
        </>
      )}
    </PageContainer>
  );
};

const PageContainer = styled.div`
  padding: 0 2rem;
  margin-bottom: 4rem;

  h1 {
    margin-top: 2rem;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    text-align: center;
    color: #951d1d;
  }
`;
